import { createTheme, DEFAULT_THEME } from '@mantine/core';

import { SwitchResolver } from '@/components/ui/Select/Switch/resolver';
import { AccordionResolver } from '@/new_src/view/components/Accordion/resolver';
import { AnchoreResolver } from '@/new_src/view/components/Anchor/resolver';
import { BadgeResolver } from '@/new_src/view/components/Badge/resolver';
import { ComboboxResolver } from '@/new_src/view/components/Combobox';
import { ContainerResolver } from '@/new_src/view/components/Container/resolver';
import { DrawerResolver } from '@/new_src/view/components/Drawer/resolver';
import { FlexResolver } from '@/new_src/view/components/Flex/resolver';
import { InputResolver, InputWrapperResolver } from '@/new_src/view/components/Inputs/resolver';
import { ModalResolver } from '@/new_src/view/components/Modal';
import { RadioResolver } from '@/new_src/view/components/Radio/resolver';

import { createRGBAWithHex } from 'utils/Color';

import { type DefaultTheme } from 'styled-components';
import { bodyTypography, fontConfig, headingsTypography } from '@/theme/headingsTypography';
import { mantineColors, mantineThemeColors } from '@/theme/mantineColors';

export const mantineTheme = createTheme({
  ...DEFAULT_THEME,
  ...fontConfig,
  focusRing: 'auto',
  /** @see https://mantine.dev/styles/rem/#rem-units-scaling */
  scale: 1.6,
  white: mantineColors.gray[1],
  black: mantineColors.gray[8],
  cursorType: 'pointer',
  colors: mantineThemeColors,
  primaryShade: 5,
  primaryColor: 'blue',
  headings: {
    sizes: headingsTypography,
  },
  radius: {
    xs: '2px',
    sm: '3px',
    md: '4px',
    lg: '6px',
    xl: '10px',
  },
  defaultRadius: 'md',
  spacing: {
    '02': '2px',
    '04': '4px',
    '06': '6px',
    '08': '8px',
    '10': '10px',
    '12': '12px',
    '16': '16px',
    '20': '20px',
    '24': '24px',
    '32': '32px',
    '40': '40px',
    '48': '48px',
    '52': '52px',
    '64': '64px',
    '80': '80px',
    '96': '96px',
    '160': '160px',
  },
  fontSizes: {
    xs: '8px',
    sm: '10px',
    md: '12px',
    lg: '14px',
    xl: '16px',
  },
  shadows: {
    md: `0px 0px 4px 0px ${createRGBAWithHex(mantineColors.gray[8], 0.2)}`,
  },
  other: {
    bodyTexts: bodyTypography,
  },
  components: {
    Modal: ModalResolver,
    Combobox: ComboboxResolver,
    Radio: RadioResolver,
    Switch: SwitchResolver,
    Input: InputResolver,
    InputWrapper: InputWrapperResolver,
    Badge: BadgeResolver,
    Container: ContainerResolver,
    Anchor: AnchoreResolver,
    Accordion: AccordionResolver,
    Flex: FlexResolver,
    Drawer: DrawerResolver,
  },
});

export const defaultTheme: DefaultTheme = {
  createRGBAWithHex,
  mantineColors,
};

export * from '@/theme/LegacyColors';
